import { NotifyHelper } from "../../../helpers/toast";
import { generateActionForKey, generateActions } from "../generateActions";
import { eDmMucHoTroNhaNuocActionsObj } from "../../action-types/category/IDmMucHoTroNhaNuocActions";

export const mucHoTroNhaNuocActions = {
  ...generateActions(eDmMucHoTroNhaNuocActionsObj, "MUC_HO_TRO_NHA_NUOC"),
  ...generateActionForKey(
    eDmMucHoTroNhaNuocActionsObj,
    "MUC_HO_TRO_NHA_NUOC",
    "SAVE_MULTIPLE_SUCCESS",
    () => {
      // id CỐ ĐỊNH: lưới tự lưu mỗi lần rời ô, gõ hết một cột là hàng chục lượt lưu — có id thì
      // react-hot-toast THAY thông báo cũ, chỉ thấy một cái duy nhất thay vì xếp chồng.
      NotifyHelper.Success("Đã lưu mức hỗ trợ", "muc-ho-tro-nha-nuoc-saved");
    },
  ),
  ...generateActionForKey(
    eDmMucHoTroNhaNuocActionsObj,
    "MUC_HO_TRO_NHA_NUOC",
    "SAVE_MULTIPLE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m ?? "Lưu thất bại");
    },
  ),
  ...generateActionForKey(
    eDmMucHoTroNhaNuocActionsObj,
    "MUC_HO_TRO_NHA_NUOC",
    "LOAD_ERROR",
    (m: string) => {
      NotifyHelper.Error(m ?? "Không tải được danh sách");
    },
  ),
};
